export function pickDefined<T extends Record<string, unknown>>(props: T) {
  return Object.fromEntries(Object.entries(props).filter(([, value]) => value != null)) as {
    [K in keyof T]?: Exclude<T[K], null | undefined>;
  };
}
